module.exports = __webpack_public_path__ + "ec16bc4cc4526801004db5bbe3b8e2c6.woff2";